import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { ContentType, Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { Newsletter } from '@utils/backend-api/newsletters';

import Content from './Content';

const queryClient = new QueryClient();

interface NewsletterLandingProps {
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  env: Env;
  newsletter: Newsletter;
}

const NewsletterLanding = ({
  initialCurrentUser,
  isGdprRequired,
  env,
  newsletter,
}: NewsletterLandingProps) => {
  const { Track } = useEventTracking({
    page: Page.NewsletterLanding,
    contentId: newsletter.id,
    contentType: ContentType.Newsletter,
  });

  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        env={env}
      >
        <QueryClientProvider client={queryClient}>
          <Content newsletter={newsletter} />
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default NewsletterLanding;
